import CodeCheckContainer from './code-check.container';

export default CodeCheckContainer;
